/* NewJaisa product page — Diwali (27 Oct 2026 experiment).
   Loaded only by the "NJ PDP Diwali" Custom Liquid section on templates/product.json.
   1. Festive frame (marigold garland, two diyas, sparkles, and the moving diya-and-flower garland border round the
      outside) on the main product gallery only: product images and
      videos, not thumbnails or any other image on the page.
   2. Keeps the Diwali coupon on Breeze Buy Now buttons while it is applied (same guard as the cart drawer copy). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DIYA = '<svg viewBox="0 0 64 52" aria-hidden="true" focusable="false"><g class="nj-pdp-deco__flame"><path d="M32 2c6 9 8 14 8 18a8 8 0 01-16 0c0-4 2-9 8-18z" fill="#ffae2b"/><path d="M32 11c3 5 4 7.5 4 9.5a4 4 0 01-8 0c0-2 1-4.5 4-9.5z" fill="#fff1b8"/></g><path d="M4 30h56c-2.5 11-13 18-28 18S6.5 41 4 30z" fill="#b8452b"/><path d="M4 30h56c-.6 2.6-1.6 4.8-3 6.8H7c-1.4-2-2.4-4.2-3-6.8z" fill="#e9a33f"/><path d="M14 40h36" stroke="#f6d37a" stroke-width="1.6" stroke-linecap="round" opacity=".7"/></svg>';

  function buildDeco() {
    var deco = document.createElement('div');
    deco.className = 'nj-pdp-deco' + (reduceMotion ? ' nj-pdp-deco--still' : '');
    deco.setAttribute('aria-hidden', 'true');
    deco.innerHTML =
      '<span class="nj-pdp-deco__garland"></span>' +
      '<span class="nj-pdp-deco__diya nj-pdp-deco__diya--l">' + DIYA + '</span>' +
      '<span class="nj-pdp-deco__diya nj-pdp-deco__diya--r">' + DIYA + '</span>' +
      '<i class="nj-pdp-deco__spark nj-pdp-deco__spark--1"></i>' +
      '<i class="nj-pdp-deco__spark nj-pdp-deco__spark--2"></i>' +
      '<i class="nj-pdp-deco__spark nj-pdp-deco__spark--3"></i>';
    return deco;
  }

  // Lift the diyas above any info bar pinned to the bottom of the gallery (e.g. "350+ Service Centers").
  function placeAboveBottomBar(stage, deco) {
    var box = stage.getBoundingClientRect();
    // Measure from inside the gallery's Diwali frame border (28 Oct), where the slides end.
    var bottom = box.bottom - (parseFloat(getComputedStyle(stage).borderBottomWidth) || 0);
    var lift = 0;
    var container = stage.closest('.product-media-container') || stage;
    Array.prototype.forEach.call(container.querySelectorAll('*'), function (el) {
      if (deco.contains(el) || /^(IMG|VIDEO|IFRAME|PICTURE|SOURCE|CANVAS)$/.test(el.tagName)) return;
      // Only bars on the slide being shown count (hidden slides have no size).
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.height < 90 && r.width > box.width * 0.6 && Math.abs(r.bottom - bottom) < 6) {
        lift = Math.max(lift, r.height);
      }
    });
    deco.style.setProperty('--nj-pdp-deco-lift', lift + 'px');
  }

  // Diwali garland frame (28 Oct): four garland sides drawn in the gallery's border, outside the photo. The gallery
  // clips its own content, so the sides live next to it in the same wrapper and are lined up with it here.
  function placeFrame(stage) {
    var holder = stage.parentElement;
    if (!holder) return;
    var frame = holder.querySelector(':scope > .nj-pdp-frame');
    if (!frame) {
      frame = document.createElement('div');
      frame.className = 'nj-pdp-frame' + (reduceMotion ? ' nj-pdp-frame--still' : '');
      frame.setAttribute('aria-hidden', 'true');
      frame.innerHTML = ['t', 'r', 'b', 'l'].map(function (s) {
        return '<span class="nj-pdp-frame__side nj-pdp-frame__side--' + s + '"></span>';
      }).join('');
      holder.appendChild(frame);
    }
    // Only touch the class once: the gallery observer below watches class changes.
    if (!stage.classList.contains('nj-pdp-framed')) stage.classList.add('nj-pdp-framed');
    if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
    var s = frame.style;
    s.left = stage.offsetLeft + 'px';
    s.top = stage.offsetTop + 'px';
    s.width = stage.offsetWidth + 'px';
    s.height = stage.offsetHeight + 'px';
  }

  function decorate() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-media-container .product-carousel'), function (stage) {
      var deco = stage.querySelector(':scope > .nj-pdp-deco');
      if (!deco) {
        deco = buildDeco();
        stage.appendChild(deco);
      }
      placeFrame(stage);
      placeAboveBottomBar(stage, deco);
    });
  }

  /* Breeze Buy Now keeps the Diwali coupon while it is applied (the cart drawer carries the same guarded copy). */
  function breezeSync() {
    if (window.__njDiwaliBreezeSync) return;
    window.__njDiwaliBreezeSync = true;
    var CODE = 'NJDW26', KEY = 'njv2_coupon_applied', queued = false;
    function applied() { try { return localStorage.getItem(KEY) === CODE; } catch (e) { return false; } }
    function sync() {
      queued = false;
      var on = applied();
      document.querySelectorAll('breeze-button').forEach(function (b) {
        if (on) { if (b.getAttribute('offercode') !== CODE) b.setAttribute('offercode', CODE); }
        else if (b.getAttribute('offercode') === CODE) { b.removeAttribute('offercode'); }
      });
    }
    function queue() { if (!queued) { queued = true; setTimeout(sync, 50); } }
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.njcp-apply-btn, .njcp-remove-btn')) queue(); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) queue(); });
    sync();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { queue(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* The Apply celebration moved to assets/nj-offer-diwali.js (3 Nov), loaded by the offer widget itself, so it
     also works in the quick-view drawer. */

  function init() {
    decorate();
    breezeSync();
    // Gallery markup can be re-rendered on variant change; put the frame back if it goes, and re-place the diyas.
    var media = document.querySelector('.product-media-container');
    if (media) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; decorate(); }, 120);
      // Slide changes only switch classes, so watch those too (not style, which decorate() itself sets).
      }).observe(media, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', function () { decorate(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
